import { List, Map } from "immutable";
import { createSelector } from "reselect";
import i18next from "i18next";


// @ts-ignore
// eslint-disable-next-line no-unused-vars
import { ICategoryTagForGeneratorMap } from "./interface";

export const getGenerator = (state: any) => state.get('persist').generator

const getGeneratorLibrariesLevels = createSelector(getGenerator, generator => {
  return generator.get('libraryLevels')
})

export const getGeneratorLibrariesLevelsListForSelect = createSelector(getGeneratorLibrariesLevels, (libraryLevels) => {
  return libraryLevels.reduce((acc: any, libraryLevel: any) => {
    return acc.push({ value: libraryLevel.id, label: `${libraryLevel.proTrackName} ${libraryLevel.name}` })
  }, List([{ value: '0', label: i18next.t('admin:Pick a ProTrack Library') }]))
})

export const getCategoriesTagsListForGenerator = createSelector(getGenerator, generator => {
  return generator.get('categoriesTagsWithActivities');
})

export const getNumberOfDaysForGenerator = createSelector(getGenerator, generator => {
  return generator.get('numberOfDays');
})

export const getCategoriesTagsListForGeneratorForm = createSelector(getCategoriesTagsListForGenerator, categoriesTags => {
  return categoriesTags.map((categoryTag: ICategoryTagForGeneratorMap) => {
    return Map({ percentage: 0, name: categoryTag.get('name'), id: categoryTag.get('id') })
  });
})

export const getMinimumPercentagePerCategoryTag = createSelector(getGenerator, generator => {
  return generator.get('minimumPercentage');
})

export const getActivitiesMapWhereKeyIsCategoryTagId = createSelector(getCategoriesTagsListForGenerator, categoriesTags => {
  return categoriesTags.reduce((acc: Map<number, object>, categoryTag: ICategoryTagForGeneratorMap) => {
    return acc.set(categoryTag.get('id'), categoryTag.get('proTrackLibraryLevelActivities'));
  }, Map())
});

export const getActivitiesListForGeneratorReplace = (categoryTagId: number) => createSelector(getActivitiesMapWhereKeyIsCategoryTagId, (categoriesTagsMap: Map<number, object>) => {
  return categoriesTagsMap.get(categoryTagId);
})

